  class AdvancedTab extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.tab-button');
      this.contents = this.querySelectorAll('.tab-content-item');

      this.buttons.forEach((btn, index) => {
        btn.dataset.index = index;
        btn.addEventListener('click', this.handleClick);
      });
    }

    disconnectedCallback() {
      this.buttons.forEach(btn =>
        btn.removeEventListener('click', this.handleClick)
      );
    }

    handleClick(event) {
      const clickedButton = event.currentTarget;
      const index = clickedButton.dataset.index;

      // Remove active from all buttons & contents
      this.buttons.forEach(btn => btn.classList.remove('active'));
      this.contents.forEach(content => content.classList.remove('active'));

      // Activate selected tab
      clickedButton.classList.add('active');
      if (this.contents[index]) {
        this.contents[index].classList.add('active');
      }
    }
  }

  customElements.define('advanced-tab', AdvancedTab);